import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import {
  Container,
  Paper,
  Typography,
  TextField,
  Button,
  Box,
  Divider,
  Alert,
} from '@mui/material';
import { Google as GoogleIcon } from '@mui/icons-material';
import { useAuth } from '../../contexts/AuthContext';
import './Login.css';

function Login() {
  const navigate = useNavigate();
  const { login, googleSignIn } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();

    try {
      setError('');
      setLoading(true);
      const result = await login(email, password);
      navigate(`/profile/${result.user.uid}`);
    } catch (error) {
      setError('Failed to sign in: ' + error.message);
    } finally {
      setLoading(false);
    }
  }

  async function handleGoogleSignIn() {
    try {
      setError('');
      setLoading(true);
      const result = await googleSignIn();
      navigate(`/profile/${result.user.uid}`);
    } catch (error) {
      setError('Failed to sign in with Google: ' + error.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <Container maxWidth={false} className="login-container">
      <Paper elevation={0} className="login-card">
        <Typography variant="h5" className="login-title">
          Welcome Back
        </Typography>

        {error && (
          <Alert severity="error" className="login-alert">
            {error}
          </Alert>
        )}

        <form onSubmit={handleSubmit}>
          <TextField
            label="Email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            variant="outlined"
            required
            autoFocus
            autoComplete="email"
          />
          <TextField
            label="Password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            variant="outlined"
            required
            autoComplete="current-password"
          />
          <Button
            type="submit"
            variant="contained"
            disabled={loading}
            className="login-button"
          >
            Sign In
          </Button>
        </form>

        <Box className="forgot-password">
          <Link to="/forgot-password" className="login-link">
            Forgot your password?
          </Link>
        </Box>

        <Box className="login-divider">
          <Divider>or continue with</Divider>
        </Box>

        <Button
          fullWidth
          variant="outlined"
          startIcon={<GoogleIcon />}
          onClick={handleGoogleSignIn}
          disabled={loading}
          className="google-button"
        >
          Google
        </Button>

        <Box className="login-footer">
          <Typography variant="body2" color="textSecondary">
            Don't have an account?{' '}
            <Link to="/signup" className="login-link">
              Sign Up
            </Link>
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
}

export default Login;
